import { render } from "./detailReservation.vue?vue&type=template&id=385a7185&scoped=true"
import script from "./detailReservation.vue?vue&type=script&lang=js"
export * from "./detailReservation.vue?vue&type=script&lang=js"

import "./detailReservation.vue?vue&type=style&index=0&id=385a7185&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385a7185"]])

export default __exports__